import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M17.75 15.5a.7.7 0 0 1-.7.7h-2.231l.295.345a.7.7 0 1 1-1.065.91l-1.281-1.5a.7.7 0 0 1 0-.91l1.281-1.5a.7.7 0 1 1 1.065.91l-.295.345h2.231a.7.7 0 0 1 .7.7ZM10.1 8.042c-.29.38-.491.937-.491 1.583 0 .647.201 1.204.492 1.584.29.38.637.55.963.55.327 0 .674-.17.964-.55.29-.38.492-.937.492-1.584 0-.646-.201-1.204-.492-1.583-.29-.38-.637-.55-.964-.55-.326 0-.673.17-.963.55ZM8.91 7.13c.508-.664 1.263-1.139 2.155-1.139.892 0 1.647.475 2.156 1.14.507.663.8 1.548.8 2.494 0 .947-.293 1.832-.8 2.495-.509.665-1.264 1.14-2.156 1.14-.892 0-1.647-.475-2.155-1.14-.508-.663-.8-1.548-.8-2.495 0-.946.292-1.83.8-2.495Z"
            clipRule="evenodd"
        />
        <path fill="currentColor" d="M8.23 12.509a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
